import { useCallback, useMemo } from 'react';
import { BankHolidayData } from '../../types/bankHoliday';
import { formatDateOnlyISO, getWeekDay } from '../../utils/dateUtil';

export const useFilterDateWeekDayAndNotBankHoliday = ({
  weekDays,
  bankHolidays,
}: {
  weekDays: number[] | undefined;
  bankHolidays?: BankHolidayData[];
}) => {
  const holidaysDates = useMemo(
    () => new Set(bankHolidays?.map((holiday) => holiday.holiday_date) || []),
    [bankHolidays],
  );

  return useCallback(
    (date: Date) => {
      const day = getWeekDay(date);
      return (
        Boolean(weekDays?.includes(day)) &&
        !holidaysDates.has(formatDateOnlyISO(date))
      );
    },
    [weekDays, holidaysDates],
  );
};
